import React, { useEffect, useState } from 'react';
import { Card, Image, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from 'assets/img/illustrations/weraise.png';

const donorNavLinks = [
  { id: 1, title: 'Project Proposal', link: 'project_proposal' },
  { id: 2, title: 'Project Progress', link: 'project_in_progress' },
  { id: 3, title: 'Complete Project', link: 'complete_project' }
];

const ProjectNav = () => {
  const [stickyStatus, setStickyStatus] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY < 10) {
        setStickyStatus(false);
      } else {
        setStickyStatus(true);
      }
    });
  }, [window.scrollY]);

  return (
    <div
      className="font-sans-serif sticky-top"
      style={{ top: stickyStatus ? '5rem' : '0' }}
    >
      <Card>
        <Card.Body>
          <div className="mb-4">
            <Image src={logo} height="24px" width="24px" />
            <span className="ms-2 fs--1 fw-medium text-900">
              Project Status
            </span>
          </div>
          <Nav variant="pills" className="flex-column">
            {donorNavLinks.map(navItem => (
              <Nav.Item key={navItem.id}>
                <Nav.Link
                  className="fs--1 fw-medium donar-profile-nav"
                  as={NavLink}
                  to={navItem.link}
                >
                  {navItem.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProjectNav;
